/**
 * Created by fers on 23.05.16.
 */

/**
 * This panel is used when we are missing any screen
 *
 * Still has to be wrapped in Relay container as our reouter count on it
 */

import React from 'react';
import PropTypes from 'prop-types';

import {RegularPanel} from './EmbededPanel.react';
import {isPanelInjected} from '../loadingLine/renderLoadingPanel.react';
import urlMapping from '../app/URLMapping';
import {openDialog, isOutlookPanel} from '../../outlook/dialog';
import {lastPanelController, sendMessage} from './EmbededPanelController';

export default class LoadingScreenPanel extends React.Component {
	reloadingOrigin = false;

	static contextTypes = {
		embededPanelController: PropTypes.object,
		router: PropTypes.object,
	};

	constructor(props) {
		super(props);
	}

	config = () => {
		lastPanelController().cancelMinimizePanel();

		let path = urlMapping.getUrl("panel", "create-screen-step-2", this.context.embededPanelController.getURLObject());

		if (isOutlookPanel()) {
			openDialog(path);
		}
		else if (isPanelInjected()) {
			sendMessage({msg: 'dativeryScreenSettings', url: path});
		}
		else {
			this.context.router.push(path);
		}
	};

	render() {
		return (<RegularPanel config={this.config} hideMinimalize isReloading typeForTest="loading-panel" />);
	}
}
